import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralPipesModule } from 'src/app/common/pipes/general-pipes.module';
import { AlbertaPageModule } from 'src/app/shared/components/alberta-page/alberta-page.module';
import { AlbertaCommonComponentsModule } from 'src/app/shared/components/common/common-components.module';
import { DesktopComponentsModule } from 'src/app/shared/components/desktop/desktop-components.module';
import { AlbertaInputsModule } from 'src/app/shared/components/inputs/inputs-components.module';
import { WizardPageModule } from 'src/app/shared/components/wizard-page/wizard-page.module';

import { AlbertaIconModule } from '../../alberta-icon/alberta-icon.module';
import { AlbertaListItemModule } from '../../common/default-listitem/listitem.module';
import { ActivityPatientSearchComponent } from './activity-patient-search.component';

@NgModule({
  declarations: [ActivityPatientSearchComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    AlbertaPageModule,
    DesktopComponentsModule,
    AlbertaCommonComponentsModule,
    IonicModule,
    GeneralPipesModule,
    AlbertaInputsModule,
    AlbertaIconModule,
    WizardPageModule,
    FormsModule,
    AlbertaListItemModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'always' }),
  ],
  exports: [ActivityPatientSearchComponent],
})
export class ActivityPatientSearchModule {}
